import { httpsCallable } from 'firebase/functions';

/**
 * @param {{ getFirebase: () => object }} opts
 */
export function createDenunciasBarrioRepository({ getFirebase }) {
  /**
   * @param {string} reportadoUid
   * @returns {Promise<{ ok?: boolean, yaDenunciado?: boolean, total?: number }>}
   */
  async function registrarDenunciaUbicacion(reportadoUid) {
    const { fns } = getFirebase();
    if (!fns) throw new Error('Servicio no disponible. Probá más tarde.');
    const call = httpsCallable(fns, 'registrarDenunciaUbicacionBarrio');
    const res = await call({ reportadoUid: String(reportadoUid || '').trim() });
    return res.data || {};
  }

  /** Pide GPS y valida contra el polígono La Victoria (Cloud Function). */
  async function ejecutarValidacionUbicacionGps() {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      throw new Error('Tu dispositivo no permite ubicación. Probá desde el celular con GPS.');
    }
    const { fns } = getFirebase();
    if (!fns) throw new Error('Servicio no disponible. Probá más tarde.');
    const pos = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        timeout: 28000,
        maximumAge: 0,
      });
    });
    const lat = pos?.coords?.latitude;
    const lng = pos?.coords?.longitude;
    const call = httpsCallable(fns, 'validarUbicacionBarrioDenuncias');
    try {
      const res = await call({ lat, lng });
      return res.data || {};
    } catch (e) {
      const msg =
        e?.message ||
        (e?.code === 'functions/failed-precondition'
          ? 'No se pudo validar la ubicación.'
          : 'Error al validar.');
      throw new Error(msg);
    }
  }

  return { registrarDenunciaUbicacion, ejecutarValidacionUbicacionGps };
}
